import getTranslatorWithFallback from './getTranslatorWithFallback'
export default getTranslatorWithFallback
